module.exports = __webpack_public_path__ + "static/img/logo.38986e87.svg";